import React from 'react'
import GroupedRegistrations from './grouped-registrations'

const GovPersonnelRecords = ({personnel, gov_registrations}) => (
  gov_registrations.map((gov_registration) => (
    <GroupedRegistrations
      key={gov_registration.gov_id}
      personnel={personnel}
      gov_registration={gov_registration}
    />
  ))
)

export default GovPersonnelRecords



// WEBPACK FOOTER //
// ./src/personnel/details/gov-personnel/views/index.jsx